export default "__VITE_ASSET__swOTdovh__"